import React, { useState } from 'react';
import _get from 'lodash/get';
import Assessments from './Assessments/index.js';
import FamilyProfile from './FamilyProfile/index.js';
import Goals from './Goals/index.js';
import Notes from './Notes/index.js';
import Progress from './Progress/index.js';
import SessionChecklist from './SessionChecklist';
import TrackingReport from './TrackingReport';
import IconPin from 'cccisd-icons/pushpin';
import IconDown from 'cccisd-icons/arrow-down20';
import IconUp from 'cccisd-icons/arrow-up20';
import IconMessage from 'cccisd-icons/envelop2';
import { useLocation, Link } from 'cccisd-react-router';
import style from './style.css';

function Family({ family, isPinned, togglePinned, familyName, getMemberName }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const location = useLocation();
    const search = location.search;
    const params = new URLSearchParams(search);
    const initialTabParam = params.get('initialTab');
    const familyIdParam = params.get('familyId');

    const familyGroupId = _get(family, 'group.groupId');
    const adults = _get(family, 'descendantRoles.tfhParentList', []) || [];
    const children = _get(family, 'descendantRoles.tfhChildList', []) || [];
    const allFamilyMembers = [...adults, ...children];

    function isStartOpen(tabKey) {
        return (
            !Number.isNaN(parseInt(familyIdParam, 10)) &&
            parseInt(familyIdParam, 10) === familyGroupId &&
            initialTabParam === tabKey
        );
    }

    return (
        <div key={familyGroupId} className={style.familyWrapper}>
            <button
                className={`btn btn-sm ${isPinned ? 'btn-primary' : 'btn-outline-primary'} ${style.pin}`}
                onClick={() => togglePinned(family)}
                type="button"
            >
                <IconPin />
            </button>
            <div className={style.collapsedContent}>
                <div className={style.familyLabel}>
                    <small>
                        <i>Family of</i>
                    </small>
                    &nbsp;&nbsp;
                    <span className="fs-3">{familyName}</span>
                </div>
                <div className={style.actions}>
                    <Notes family={family} familyName={familyName} isStartOpen={isStartOpen('notes')} />
                    <Assessments
                        allFamilyMembers={allFamilyMembers}
                        family={family}
                        familyName={familyName}
                        getMemberName={getMemberName}
                        isStartOpen={isStartOpen('assessments')}
                    />
                    <Progress family={family} familyName={familyName} isStartOpen={isStartOpen('progress')} />
                    <SessionChecklist
                        family={family}
                        familyName={familyName}
                        isStartOpen={isStartOpen('sessionChecklist')}
                    />
                    <FamilyProfile family={family} familyName={familyName} isStartOpen={isStartOpen('familyProfile')} />
                </div>
                <div className={style.expandButton}>
                    <button type="button" className="btn btn-sm btn-link" onClick={() => setIsExpanded(prev => !prev)}>
                        {isExpanded ? 'Less' : 'More'}
                        {isExpanded ? <IconUp spaceLeft /> : <IconDown spaceLeft />}
                    </button>
                </div>
            </div>
            {isExpanded && (
                <div className={style.expandedContent}>
                    <table className={'table table-sm ' + style.membersTable}>
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Role</th>
                                <th scope="col">Last Login</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allFamilyMembers.map(member => {
                                const memberDisplayName = getMemberName(member);
                                return (
                                    <tr key={member.pawn.pawnId}>
                                        <td>{memberDisplayName}</td>
                                        <td>{member.role.handle.replace(/^tfh/i, '')}</td>
                                        <td>{member.user.lastLoginDate || '-'}</td>
                                        <td className={style.actions}>
                                            <Goals member={member} memberDisplayName={memberDisplayName} />
                                            <TrackingReport member={member} memberDisplayName={memberDisplayName} />
                                            {member.role.handle === 'tfhParent' && (
                                                <Link to={`/messages/${member.pawn.pawnId}`}>
                                                    <button className="btn btn-sm btn-secondary" type="button">
                                                        <IconMessage spaceRight />
                                                        Message
                                                    </button>
                                                </Link>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default Family;
